export default "__VITE_ASSET__COVKw$E1__"